import { DomainSupplyChain } from 'features/globalSetup/types/domainSupplyChain'
import { mapToFormField } from './mapper'
import { Schema } from './schema'

export const defaults = (domainSupplyChains: DomainSupplyChain[]): Schema => ({
  domainSupplyChainsSids: mapToFormField(domainSupplyChains),
})
